import React, { useState } from 'react';
import { useTable, usePagination } from 'react-table';
import Modal from '../../../../components/Modal/Modal';
import EmptyData from '../../../../components/EmptyData/EmptyData';
import Loader from '../../../../components/Loader/Loader';
import icon from '../../../../brand/generated/buttonIcons/addDeal.svg';
import getDealHistory from '../../../../api/deals/getDealHistory';
import { DEAL_HISTORY } from '../../../../constants/columns';

const columns = DEAL_HISTORY;

const DealHistoryModal = ({ dealId, isOpen, onClose }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  const table = useTable(
    {
      columns,
      data: history,
      initialState: { pageIndex: 0, pageSize: 1000000 },
    },
    usePagination
  );

  const init = async () => {
    setLoading(true);
    await getDealHistory({ id: dealId })
      .then((res) => {
        setHistory(res?.data || []);
      })
      .finally(() => setLoading(false));
  };

  React.useEffect(() => {
    if (isOpen && dealId) init();
  }, [isOpen, dealId]);

  return (
    <Modal
      isOpen={isOpen}
      title="История изменений сделки"
      onRequestClose={onClose}
      contentStyle={{
        top: '10%',
        height: 'fit-content',
        width: 900,
      }}
    >
      {loading ? (
        <Loader />
      ) : (
        <EmptyData
          title={`История (${history.length})`}
          subtitle={'По этой сделке пока нет изменений в составе оборудования, услуг или автомобилей.'}
          action={null}
          icon={icon}
          table={table}
          data={history}
        />
      )}
    </Modal>
  );
};

export default DealHistoryModal;
